import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DialogService, CoreService, SpinnerService, DataService, SaveDataRequest, VerticalNavigationSettings, SaveFormEvent, FormHeaderModel, FormNavigationService, ElementType, DialogResult, Option } from 'dspx-core';
import { Subscription, bufferTime, filter, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, OPTION_SETS, PAGE_NUMBERS, POP_UP_CODES, POP_UP_HEADER, POP_UP_TEXTS, QUESTION_CODES, SECTION_CODES, SERVER_ERROR_POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import * as _ from 'lodash';
import { ConcessionsApplicationBaseComponent } from '../concessions-application-base-component/concessions-application-base-component';
import { Guid } from 'guid-typescript';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'concessions-application-app-non-mains-energy',
  templateUrl: './concessions-application-non-mains-energy.component.html',
  styleUrls: ['./concessions-application-non-mains-energy.component.scss']
})
export class ConcessionsApplicationNonMainsEnergyComponent extends ConcessionsApplicationBaseComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  private _previousTab: number = 1;
  private _previousPage: number = 1;
  private _currentTab: number = 1;
  private _currentPage: number = 1;

  templateId: number = TEMPLATES.concessionsApplicationNonMainsEnergy;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  primaryAddressIsManual: boolean = false;
  activeApplications: any;
  previousApplications: any;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private viewportScroller: ViewportScroller
  ) {
    super(router, route, dataService, appDataService, responseParserService, dialogService, spinnerService, errorService);
  }

  ngOnInit(): void {
    this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsApplicationNonMainsEnergyConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.concessionsApplicationNonMainsEnergy.save;

    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        const personId = paramMap.get('personId');

        if (id) {
          this.id = id;
          this.editing = true;
        } else if (personId) {
          this.id = `${Guid.EMPTY}/${personId}`
          this.personId = personId;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      isPrimaryAddressManual: () => this.isPrimaryAddressManual(),
      isPrimaryAddressAuto: () => this.isPrimaryAddressAuto(),
      showCenterlinkCardDetails: () => this.showCenterlinkCardDetails(),
      showVeteransAffairsCardDetails: () => this.showVeteransAffairsCardDetails(),
      showPensionerCardIssuer: () => this.showPensionerCardIssuer(),
      exit: () => this.exit(),
      true: () => true,
      false: () => false,
      readOnly: () => true,

      showNonMainEnergyElectricityInvoiceSection: () => this.showNonMainEnergyElectricityInvoiceSection(),
      showNonMainEnergyElectricityStatDec: () => this.showNonMainEnergyElectricityStatDec(),
      showNonMainEnergyElectricityInvoice: () => this.showNonMainEnergyElectricityInvoice(),

      showNonMainEnergyGasInvoiceSection: () => this.showNonMainEnergyGasInvoiceSection(),
      showNonMainEnergyGasStatDec: () => this.showNonMainEnergyGasStatDec(),
      showNonMainEnergyGasInvoice: () => this.showNonMainEnergyGasInvoice(),

      showNonMainEnergyOilInvoiceSection: () => this.showNonMainEnergyOilInvoiceSection(),
      showNonMainEnergyOilStatDec: () => this.showNonMainEnergyOilStatDec(),
      showNonMainEnergyOilInvoice: () => this.showNonMainEnergyOilInvoice(),

      showNonMainEnergyFirewoodInvoiceSection: () => this.showNonMainEnergyFirewoodInvoiceSection(),
      showNonMainEnergyFirewoodStatDec: () => this.showNonMainEnergyFirewoodStatDec(),
      showNonMainEnergyFirewoodInvoice: () => this.showNonMainEnergyFirewoodInvoice(),

      showNonMainEnergyFuelInvoiceSection: () => this.showNonMainEnergyFuelInvoiceSection(),
      showNonMainEnergyFuelStatDec: () => this.showNonMainEnergyFuelStatDec(),
      showNonMainEnergyFuelInvoice: () => this.showNonMainEnergyFuelInvoice(),

      isConsentNotAgree: () => this.isConsentNotAgree(),
      isConsentAgree: () => this.isConsentAgree(),
      isConsentNotsignedandNoConfirmation: () => this.isConsentNotsignedandNoConfirmation(),
      showSignedApplicationUpload: () => this.showSignedApplicationUpload(),
      isCustomerPortalApplication: () => this.isCustomerPortalApplication(),
      isStaffPortalApplication: () => this.isStaffPortalApplication(),
      addNewPostalAddress: () => this.addNewPostalAddress(),
      isReadOnly: () => this.isReadOnly(),
      isEditOrStaffPortalApplication: () => true,
      isFirstNameReadonly: () => this.isFirstNameReadonly(),
      isLastNameReadonly: () => this.isLastNameReadonly(),
      isEmailReadonly: () => this.isEmailReadonly(),
      isMobilePhoneReadonly: () => this.isMobilePhoneReadonly(),
      isOtherPhoneReadonly: () => this.isOtherPhoneReadonly(),
      isDateOfBirthReadonly: () => this.isDateOfBirthReadonly(),
      isPrimaryAddressReadonly: () => this.isPrimaryAddressReadonly(),
      isPostalAddressSameAsPrimaryAddressReadonly: () => this.isPostalAddressSameAsPrimaryAddressReadonly(),
      isPostalAddressReadonly: () => this.isPostalAddressReadonly()
    }

    this.coreService.applicationFunctions = {
      exit: () => this.exit(),
      showInvoiceSectionHelp: () => this.showInvoiceSectionHelp(),
      fileUploadOnBeforeRemoveInvoiceElectricity: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceElectricity(file, onComplete),
      fileUploadOnBeforeRemoveInvoiceGas: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceGas(file, onComplete),
      fileUploadOnBeforeRemoveInvoiceOil: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceOil(file, onComplete),
      fileUploadOnBeforeRemoveInvoiceFirewood: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceFirewood(file, onComplete),
      fileUploadOnBeforeRemoveInvoiceFuel: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceFuel(file, onComplete)
    }

    this.coreService.repeatingSectionFunctions = {
      onSaveInvoiceElectricity: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceElectricity(itemIndex, onComplete),
      onSaveInvoiceGas: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceGas(itemIndex, onComplete),
      onSaveInvoiceOil: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceOil(itemIndex, onComplete),
      onSaveInvoiceFirewood: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceFirewood(itemIndex, onComplete),
      onSaveInvoiceFuel: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceFuel(itemIndex, onComplete),
      onBeforeRemoveInvoiceElectricity: (itemIndex, callback) => this.onBeforeRemoveInvoiceElectricity(itemIndex, callback),
      onBeforeRemoveInvoiceGas: (itemIndex, callback) => this.onBeforeRemoveInvoiceGas(itemIndex, callback),
      onBeforeRemoveInvoiceOil: (itemIndex, callback) => this.onBeforeRemoveInvoiceOil(itemIndex, callback),
      onBeforeRemoveInvoiceFirewood: (itemIndex, callback) => this.onBeforeRemoveInvoiceFirewood(itemIndex, callback),
      onBeforeRemoveInvoiceFuel: (itemIndex, callback) => this.onBeforeRemoveInvoiceFuel(itemIndex, callback)
    };

    this.registerSaveOnNavigation();
  }

  fileUploadOnBeforeRemoveInvoiceFuel(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFuel;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentFuel === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalFuel) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  fileUploadOnBeforeRemoveInvoiceOil(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoOil;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentOil === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalOil) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  fileUploadOnBeforeRemoveInvoiceFirewood(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFirewood;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentFirewood === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalFirewood) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  fileUploadOnBeforeRemoveInvoiceGas(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoGas;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentGas === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalGas) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  fileUploadOnBeforeRemoveInvoiceElectricity(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoElectricity;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentElectricity === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalElectricity) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  showInvoiceSectionHelp() {
    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invoiceHelpText);
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.formNavSubscription.unsubscribe();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    super.formLoad($event);
    this.activeApplications = $event.activateApplications;
    this.formHeaderModel = $event.headerResponse;
    this.isPersonBothCarerAndConcessionsApplicant = $event.isPersonBothCarerAndConcessionsApplicant;
    this.isPersonWithActiveCareAllowancePlacements = $event.isPersonWithActiveCareAllowancePlacements;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.entitlementLetter] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.signedApplication] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentElectricity] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.statDecDocumentElectricity] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentGas] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.statDecDocumentGas] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentOil] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.statDecDocumentOil] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentFirewood] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.statDecDocumentFirewood] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentFuel] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.statDecDocumentFuel] = FORM_IDENTIFIERS.concessionsFormIdentifier;
  }

  home(event: any) {
    this.navigateBackToHome();
  }

  exit() {
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (event.isSubmit) {
      if (event.isFormValid === false) {
        this.baseForm.markAllFieldsAsTouched();
        this.baseForm.showValidationSummary(true);
      }
      else {
        // submit application
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    if (this.formNavigationService.currentTabIndex == 0 && this.formNavigationService.currentPageIndex == 0) {
      this.navigateToConcessionsInfo();
    } else {
      this.formNavigationService.moveBack();
    }
  }

  buttonClick(event: any): void {
  }

  actionButtonClick(event: any): void {
  }

  dialogSubmit(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.concessionsApplicationCommon.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
    }
  }

  filter(event: any): void {
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {
      var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      if (addressSection) {
        var value = addressSection[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.primaryAddressManualAddress];
        this.primaryAddressIsManual = (value === true);
      }

      this.UpdateHeaderAndApplicationPeriod();
    }
  }

  private UpdateHeaderAndApplicationPeriod() {
    let applicationPeriod = this.updateHeaderSubtitle(this.baseForm.optionSets.calendaryear as Option[]);
    if (applicationPeriod) {
      this.baseForm.model.form.tabs.tab5.page1.documentInfo.applicationPeriod = applicationPeriod;
    }
  }

  isPrimaryAddressManual(): boolean {
    return this.primaryAddressIsManual;
  }

  isPrimaryAddressAuto(): boolean {
    return !this.primaryAddressIsManual;
  }

  showCenterlinkCardDetails(): boolean {
    //only displays if Card Type == 'Pensioner Concession Card' AND Pensioner Card Issuer = 'Centrelink' (selected as the issuer)
    //Or Card Type == 'Health Care Card'
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;
    let centrelinkCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.centrelinkCardNumber;

    let result = cardType === OPTION_SETS.concessionsCardType.options.healthCareCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.centrelink);

    // setting the Centrelink Card Number
    if (result === true && !centrelinkCardNumber) {
      let profileCentrelinkCardNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileCentrelinkCardNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsEnergyForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.centrelinkCardNumber],
        profileCentrelinkCardNumber);
    }

    return result;
  }

  showVeteransAffairsCardDetails(): boolean {
    //only displays if 'Pensioner Concession Card' AND 'Veterans Affairs' (selected as the issuer)
    //OR 'Veterans Affairs Gold Card' selected on above question
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;
    let veteransAffairsCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.veteransAffairsCardNumber;

    let result = cardType === OPTION_SETS.concessionsCardType.options.veteransAffairsGoldCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.veteransAffairs);

    // setting the Veterans Affairs File Number
    if (result === true && !veteransAffairsCardNumber) {
      let profileVeteransAffairsFileNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileVeteransAffairsFileNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsEnergyForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.veteransAffairsCardNumber],
        profileVeteransAffairsFileNumber);
    }

    return result;
  }

  showPensionerCardIssuer(): boolean {
    return (this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard);
  }
 
  private registerSaveOnNavigation() {
    this.formNavSubscription =
      this.formNavigationService.onNavigation()
        .pipe(
          bufferTime(200),
          filter(x => x.length > 0)
        ).subscribe(async (data) => {
          this.viewportScroller.scrollToPosition([0, 0]); //Always navigate to the top of the page

          let tabNumber = data.find(x => x.elementType === ElementType.TAB)?.elementNumber
          let pageNumber = data.find(x => x.elementType === ElementType.PAGE)?.elementNumber

          if (this.coreService.isFormEditable === true) {
            // If the user is navigating forwards
            if (tabNumber > this._currentTab || pageNumber > this._currentPage) {

              //introduction confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.intro
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.intro) {

                if (!this.selectedApplyForYear) {
                  this.UpdateHeaderAndApplicationPeriod();
                }

                if (this.activeApplications) {
                  // check if there is active application for selected year
                  const selectedApplicationYearApplicationsCount = this.activeApplications
                    .filter(item => item.applicationYear === this.selectedApplyForYear)
                    .map(item => item.count)
                    .find(count => count !== undefined);

                  if (selectedApplicationYearApplicationsCount != null && selectedApplicationYearApplicationsCount > 0) {
                    this.activeDialog = POP_UP_CODES.concessionsApplicationCommon.applicationInProgress;
                    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.applicationInProgress, null, { applicationYear: this.applicationPeriod }, false);

                    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                    return;
                  }
                }
              }

              //check address is in victoria
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.applicant
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.applicant) {
                const addressInVic = this.isAddressInVictoria(this.baseForm.model.form.tabs.tab2.page1.address, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.primaryAddress)
                if (!addressInVic) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invalidResidentialAddress);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }
              }

              // Rates upload single check box validation
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.ratesUpload
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.ratesUpload) {
                if (!this.checkIfAtleastOnesingleCheckboxSelectedOnRatesPage()) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.ratesValidation);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }
              }

              //Invoice confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsEnergyForm.invoice
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsEnergyForm.invoice) {
                const invoicePage = this.baseForm.model.form.tabs.tab5.page1;
                if (!this.checkSupportingDocCheckboxSelectedOnInvoice(invoicePage.documentInfo)) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.checkSupportingDocValidation);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }

                // The user is attempting to navigate away from the invoice page
                // If any of invoice section are expanded, then we want to prevent navigation forwards, and show
                // a popup telling the user they must save their invoice before proceeding.
                const isAnyInvoiceInEditMode = this.checkIfAnyInvoiceIsInEditMode(
                  invoicePage.invoiceInfoElectricity,
                  invoicePage.invoiceInfoGas,
                  invoicePage.invoiceInfoOil,
                  invoicePage.invoiceInfoFuel,
                  invoicePage.invoiceInfoFirewood
                );

                if (isAnyInvoiceInEditMode) {
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);

                  // Show a dialog.
                  this.dialogService.showSimplePopup(POP_UP_TEXTS.common.saveInvoice, POP_UP_HEADER.common.saveInvoice);
                  return;
                }
              }

              // This condition added to avoid calling backend API more than once
              // on component initialization.
              if (this._previousPage !== this._currentPage || this._previousTab !== this._currentTab) {
                this._previousTab = this._currentTab;
                this._previousPage = this._currentPage;
                if (this.isDraftApplication) {
                  this.saveOnNavigation(this.templateId, this.versionNo);
                }
              }
            }
          }


          this._currentTab = tabNumber ?? this._currentTab;
          this._currentPage = pageNumber ?? this._currentTab;
        });
  }

  private calculateTotalInvoiceAmount(invoiceInfoArray, propertyName) {
  return invoiceInfoArray ?
    invoiceInfoArray.reduce((total, entry) => total + entry[propertyName], 0) : 0;
}

  private findClosestPaymentAmount(value, data) {
    let closestLine = null;
    let closestDifference = Infinity;

    for (const entry of data) {
      const difference = entry.maxThresholdAmounts - value;
      if (difference >= 0 && difference < closestDifference) {
        closestDifference = difference;
        closestLine = entry;
      }
    }
    return closestLine;
  }

  private checkIfAtleastOnesingleCheckboxSelectedOnRatesPage() {
    var energyType = this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType;
    if (energyType) {
      return _.some(_.values(energyType), (value: any) => value === true);
    } else {
      return false;
    }
  }

  private onSaveInvoiceElectricity(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    //check date of invoice
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoElectricity;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceInfo[itemIndex]?.invoiceDateElectricity);
    const totalInvoiceAmt = this.updateTotalInvoiceAmt(invoiceInfo, invoiceDate, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountElectricity);
    if (totalInvoiceAmt) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadElectricity.invoiceTotalElectricity = totalInvoiceAmt;
      const fileName = this.extractFileName(invoiceInfo[itemIndex].invoiceDocumentElectricity);
      invoiceSelected.filenameElectricity = fileName;
      invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountElectricity] = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountElectricity]);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDateValidation);
      onComplete(true);
    }
  }
  
  private onSaveInvoiceGas(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoGas;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected?.invoiceDateGas);
    const totalInvoiceAmt = this.updateTotalInvoiceAmt(invoiceInfo, invoiceDate, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountGas);
    if (totalInvoiceAmt) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadGas.invoiceTotalGas = totalInvoiceAmt;
      const fileName = this.extractFileName(invoiceSelected.invoiceDocumentGas);
      invoiceSelected.filenameGas = fileName;
      invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountGas] = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountGas]);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDateValidation);
      onComplete(true);
    }
  }

  private onSaveInvoiceOil(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoOil;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected?.invoiceDateOil);
    const totalInvoiceAmt = this.updateTotalInvoiceAmt(invoiceInfo, invoiceDate, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountOil);
    if (totalInvoiceAmt) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadOil.invoiceTotalOil = totalInvoiceAmt;
      const fileName = this.extractFileName(invoiceSelected.invoiceDocumentOil);
      invoiceSelected.filenameOil = fileName;
      invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountOil] = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountOil]);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDateValidation);
      onComplete(true);
    }
  }

  private onSaveInvoiceFirewood(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFirewood;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected?.invoiceDateFirewood);
    const totalInvoiceAmt = this.updateTotalInvoiceAmt(invoiceInfo, invoiceDate, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFirewood);
    if (totalInvoiceAmt) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadFirewood.invoiceTotalFirewood = totalInvoiceAmt;
      const fileName = this.extractFileName(invoiceSelected.invoiceDocumentFirewood);
      invoiceSelected.filenameFirewood = fileName;
      invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFirewood] = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFirewood]);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDateValidation);
      onComplete(true);
    }
   }  

  private onSaveInvoiceFuel(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFuel;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected?.invoiceDateFuel);
    const totalInvoiceAmt = this.updateTotalInvoiceAmt(invoiceInfo, invoiceDate, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFuel);
    if (totalInvoiceAmt) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadFuel.invoiceTotalFuel = totalInvoiceAmt;
      const fileName = this.extractFileName(invoiceSelected.invoiceDocumentFuel);
      invoiceSelected.filenameFuel = fileName;
      onComplete(false);
      invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFuel] = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFuel]);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDateValidation);
      onComplete(true);
    }
  }

  private onBeforeRemoveInvoiceElectricity(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoElectricity;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortalElectricity === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountElectricity;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadElectricity.invoiceTotalElectricity = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private onBeforeRemoveInvoiceGas(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoGas;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortalGas === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountGas;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadGas.invoiceTotalGas = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private onBeforeRemoveInvoiceOil(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoOil;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortalOil === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountOil;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadOil.invoiceTotalOil = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private onBeforeRemoveInvoiceFirewood(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFirewood;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortalFirewood === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFirewood;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadFirewood.invoiceTotalFirewood = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private onBeforeRemoveInvoiceFuel(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoFuel;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortalFuel === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceAmountFuel;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadFuel.invoiceTotalFuel = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private updateTotalInvoiceAmt(invoiceInfo: any, invoiceDate: Date, propertyName: string): string {
    const applicationPeriodDates = this.baseForm.model.form.tabs.tab5.page1.documentInfo.applicationPeriod.split(' to ');
    const fromDate = new Date(applicationPeriodDates[0]);
    const toDate = new Date(applicationPeriodDates[1]);
    // add 30 days to toDate
    toDate.setDate(toDate.getDate() + 30);
    const invoiceDateOk = invoiceDate >= fromDate && invoiceDate <= toDate;
    if (invoiceDateOk) {
      // add the total of invoices
      let invoiceTotal: number = 0;
      invoiceInfo.forEach(item => {
        invoiceTotal = invoiceTotal + parseFloat(item[propertyName]);
      });
      return "$" + invoiceTotal.toFixed(2);
    } else {
      return null;
    }
  }

  private showNonMainEnergyElectricityStatDec(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadElectricity?.documentTypeElectricity;
    return this.isStatDec(docType);
  }
  
  private showNonMainEnergyOilStatDec(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadOil?.documentTypeOil;
    return this.isStatDec(docType);
  }

  private showNonMainEnergyGasStatDec(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadGas?.documentTypeGas;
    return this.isStatDec(docType);
  }

  private showNonMainEnergyFirewoodStatDec(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadFirewood?.documentTypeFirewood;
    return this.isStatDec(docType);
  }
  
  private showNonMainEnergyFuelStatDec(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadFuel?.documentTypeFuel;
    return this.isStatDec(docType);
  }

  private showNonMainEnergyElectricityInvoice(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadElectricity?.documentTypeElectricity;
    return this.IsInvoice(docType);
  }
  
  private showNonMainEnergyGasInvoice(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadGas?.documentTypeGas;
    return this.IsInvoice(docType);
  }

  private showNonMainEnergyOilInvoice(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadOil?.documentTypeOil;
    return this.IsInvoice(docType);
  }

 private showNonMainEnergyFirewoodInvoice(): boolean {
   var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadFirewood?.documentTypeFirewood;
   return this.IsInvoice(docType);
  }

  private showNonMainEnergyFuelInvoice(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadFuel?.documentTypeFuel;
    return this.IsInvoice(docType);
  }

  private showNonMainEnergyElectricityInvoiceSection(): boolean {
    //Displays if 'Non-mains electricity' energy sub - type selected
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType?.nonMainsElectricity;
  }

  private showNonMainEnergyGasInvoiceSection(): boolean {
    //Displays if 'Non-mains gas' energy sub-type selected
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType?.nonMainGas;
  }

  private showNonMainEnergyOilInvoiceSection(): boolean {
    //Displays if 'Heating oil' energy sub-type selected
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType?.heatingOil;
  }

  private showNonMainEnergyFirewoodInvoiceSection(): boolean {
    //Displays if 'Firewood...' energy sub-type selected
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType?.firewoodSawdustWoodPellet;
  }

  private showNonMainEnergyFuelInvoiceSection(): boolean {
    //Displays if 'Generator fuel' energy sub-type selected
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.energyType?.generatorFuel;
  }

  private isStatDec(docType: string): boolean {
    if (docType) {
      return (docType === OPTION_SETS.concessionsDocType.options.statutorydeclaration);
    }
    return false;
  }

  private IsInvoice(docType: string): boolean {
    if (docType) {
      const isInvoice = (docType === OPTION_SETS.concessionsDocType.options.invoice);
      if (isInvoice === true && !this.baseForm.model.form.tabs.tab5.page1.documentInfo.applicationPeriod) {
        this.baseForm.model.form.tabs.tab5.page1.documentInfo.applicationPeriod = this.applicationPeriod;
      }
      return isInvoice;
    }
    return false;
  }
}
